module.exports = __webpack_public_path__ + "img/dribbling.46ddfdd3.png";